import { IEntityPickerFetcher } from './entityPickerFetcher';
import { IEpickNode } from './EpickTree';
import { ITreeNode } from 'components/Tree/CommonTree/CommonTreeNode';
import { IEntityPickerTreeModel, getTreeNode } from './defaultEpickTreeModel';
import { EntityPickerSettings } from '@decisions/server/DecisionsFramework/Design/Properties/Attributes';
import { splitNameAndType } from './decisionsTypeTreeModel';

/**
 * DefaultEntityPickerTreeModel
 */
export function globalSearchEntityPickerTreeModel(
  searchText: string,
  settings: EntityPickerSettings,
  dataFetcher: IEntityPickerFetcher
): IEntityPickerTreeModel {
  const getRootNodes = async (): Promise<ITreeNode<IEpickNode>[]> => {
    const entities = await dataFetcher.searchEntities(searchText);
    return (
      entities.map(e => {
        const [name, type] = splitNameAndType(e.EntityName);
        return getTreeNode({
          id: e.Id,
          name: name,
          pickable: true,
          canBeFav: true,
          favoriteType: e.FavoriteType,
          entity: e,
          title: type
        } as IEpickNode);
      }) ?? []
    );
  };

  const getSubNodes = async (): Promise<ITreeNode<IEpickNode>[]> => {
    return [];
  };

  return { getSubNodes, getRootNodes, search: searchText };
}
